import {createContext} from 'react'

const EstatusSolicitudesComprasContext = createContext()

export default EstatusSolicitudesComprasContext